import { render, staticRenderFns } from "./Bottarget.vue?vue&type=template&id=6606bfde&scoped=true"
import script from "./Bottarget.vue?vue&type=script&lang=js"
export * from "./Bottarget.vue?vue&type=script&lang=js"
import style0 from "./Bottarget.vue?vue&type=style&index=0&id=6606bfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6606bfde",
  null
  
)

export default component.exports